import { SearchDateType, SearchOrigin } from './catalogs/CustomSearch'

export enum TemplateQuestionsTypes {
  LABEL = 'label',
  GROUP = 'group',
  ADDRESS = 'address',

  TEXT = 'text',
  PHONE = 'phone',
  EMAIL = 'email',
  INTEGER = 'integer',
  DECIMAL = 'decimal',
  CURRENCY = 'currency',
  BOOLEAN = 'boolean',

  DATE = 'date',
  DATETIME = 'dateTime',
  TIME = 'time',

  PHOTO = 'photo',
  AUDIO = 'audio',
  PDF = 'pdf',
  SIGNATURE = 'signature',
  FILE = 'file',

  SELECT = 'select',

  LOCATION = 'location'
}

export interface GeoDistanceFillgridFilter {
  kilometers: number
  location: {
    latitude: number
    longitude: number
  }
}

export class FillgridFilters {
  name = ''
  dateType = SearchDateType.RECEIVED
  dates = [] as Date[]
  fullHistory = false
  status = 0
  user = ''
  altuser = ''
  fullSearch = ''
  idents = [] as any[]
  custom = [] as any[]
  nextCursor = ''
  view = 0
  origin: SearchOrigin = SearchOrigin.FILLGRID
  geoDistance: GeoDistanceFillgridFilter = {
    kilometers: 0,
    location: {
      latitude: 0,
      longitude: 0
    }
  }

  constructor () {
    const endDate = new Date()
    const startDate = new Date() // moment(endDate).add(-31, 'days').toDate()
    this.dates = [startDate, endDate]
  }
}

export class TemplateQuestion {
  id: string
  identity?: boolean
  offset?: number
  displayName?: boolean
  label: string
  type: TemplateQuestionsTypes
  required: boolean
  requiredForIntegration?: boolean
  readOnly?: boolean
  editOnce?: boolean
  sticky?: boolean
  strict?: boolean
  static?: boolean
  protection?: number
  expression?: string
  constraint?: {
    type: string,
    value: string
  }
  sealant?: {}
  secret: boolean
  pivot: string
  questions?: TemplateQuestion[]
}

export class TemplateDetail {
  label: string
  autoUpdate: boolean
  blockFillsCreation: boolean
  blockFillsDeletion: boolean
  creationDate: Date
  updateDate: Date
  version: number
  idents: string[]
  questions: TemplateQuestion[]
}

export enum EditableFillgridColumnDates {
  ACTIVATION = '_activationDate',
  EXPIRATION = '_expirationDate'
}

export class FillgridColumn {
  questionRef: any
  base: boolean
  number: string
  name: string
  label: string
  type: TemplateQuestionsTypes
  icon: string
  ident: boolean
  metadata: boolean

  constructor (questionRef: any, number: string, name: string, label: string, type: TemplateQuestionsTypes, base?: boolean, icon?: string) {
    this.questionRef = questionRef
    this.number = number
    this.name = name
    this.label = label
    this.type = type
    this.base = base || false
    this.icon = icon || ''
  }

  isIdent () {
    this.ident = true
    return this
  }

  isMetadata () {
    this.metadata = true
    return this
  }

  /**
   * Validates if one fillgrid column is a computed field,
   * this could be of type Text, Integer, Decimal or Currency with a sealant and an expression.
   */
  isComputed (): boolean {
    return (
      this.type === TemplateQuestionsTypes.TEXT ||
      this.isNumericColumn()
    ) &&
      this.questionRef.expression &&
      this.questionRef.sealant
  }

  isNumericColumn (): boolean {
    return this.type === TemplateQuestionsTypes.INTEGER ||
      this.type === TemplateQuestionsTypes.DECIMAL ||
      this.type === TemplateQuestionsTypes.CURRENCY
  }

  /**
   * @returns true if it is a column date that can be modified
   */
  isEditableColumnDate () {
    return Object.values(EditableFillgridColumnDates).includes(this.name as EditableFillgridColumnDates)
  }

  /**
   * @returns true if it is a column date that can be modified
   */
  static isEditableColumnDate (name: string) {
    return Object.values(EditableFillgridColumnDates).includes(name as EditableFillgridColumnDates)
  }

  /**
   * We add an underscore to a column name in case this has only numbers
   *
   * @param column name to get
   * @returns the name for a column
   */
  static getColumnName (column: string): string {
    return FillgridColumn.isColumnNameANumber(column) ? `_${column}` : column
  }

  /**
   * This validates if a column name contains a format number
   *
   * @param column name
   * @returns true if the column name has only numbers
   */
  static isColumnNameANumber (column: string): boolean {
    return !isNaN(parseFloat(column))
  }
}

export class FillgridEntry {
  id: number
  user: string
  altUser: string
  creationDate: Date
  receivedDate: Date
  sentDate: Date
  startDate: Date
  updateDate: Date
  status: string
  uploads: number
  editCount: number
  editDuration: number
  last: boolean
  ident0: string
  ident1: string
  completedFields: number
  values: any
  selected: boolean
}

export interface FillgridEntryValue {
}

export class FillgridEntryValueLocation {
  altitude: number
  latitude: number
  longitude: number
}

export class FillgridEntryValuePhoto {
  date: Date
  name: string
}

export class FillgridViewFilters {
  name: string
}

export class FillgridSearchFilters {
  name: string
  origin: SearchOrigin
}
